/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { Organization } from "chq";
import { isPremiseHealth, isRTX, isSynopsys } from "app/utils";
import PostStoryMedia from "./PostStoryMedia";
import PostStoryEditor from "./PostStoryEditor";
import StoryDisclaimer from "./StoryDisclaimer";

interface RightColumnProps {
  isMobile: boolean;
  showUnsplashSearch: boolean;
  organization?: Organization;
}

const PostStoryRightColumn: React.FC<RightColumnProps> = ({
  isMobile,
  showUnsplashSearch,
  organization
}) => {
  const { name: organizationName } = organization || {};

  return (
    <div className="RightColumn">
      {!isMobile && <PostStoryMedia />}
      {!isMobile && (
        <div className={showUnsplashSearch ? "hidden" : "visible"}>
          <PostStoryEditor />
        </div>
      )}
      {(isPremiseHealth(organizationName) || isRTX(organizationName) || isSynopsys(organizationName)) && <StoryDisclaimer organizationName={organizationName || ""} />}
    </div>
  );
};

export default PostStoryRightColumn;
